import { Injectable, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from 'firebase/auth';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable, first, map, of } from 'rxjs';
import { FIREBASE_AUTH } from '../firebase.tokens';

@Injectable({ providedIn: 'root' })
export class AuthResolver implements Resolve<boolean> {
  private auth: Auth = inject(FIREBASE_AUTH);
  private router = inject(Router);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (route.queryParams['mode'] || route.queryParams['session']) {
      return of(true);
    }
    return new Observable((subscriber) =>
      onAuthStateChanged(
        this.auth,
        (user) => subscriber.next(user),
        (err) => subscriber.error(err),
      ),
    ).pipe(
      first(),
      map((user) => {
        if (user) {
          console.log('redirect');
          this.router.navigateByUrl('/');
          return false;
        } else {
          return true;
        }
      }),
    );
  }
}
